import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {BillingComponent} from './billing.component';
import {routing} from './billing.routing';
import {FormsModule} from '@angular/forms';
import {HttpModule} from '@angular/http';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {MultiSelectModule} from 'primeng/primeng';
import {CollapseModule, ModalModule} from 'ngx-bootstrap';
// for loading theme
import {LayoutModule} from '../layout/layout.module';
import {SharedTranslationModule} from '../shared/change-language/shared-translation.module';
import {BillingService} from './billing.service';
import {OpdPatientConfigService} from '../configuration/application-configuration/opd-patient-config/opd-patient-config.service';


@NgModule({
  imports: [
    CommonModule, SharedTranslationModule,
    routing,
    LayoutModule,
    FormsModule,
    HttpModule,
    BrowserAnimationsModule,
    MultiSelectModule,
    CollapseModule.forRoot(),
    ModalModule.forRoot()
  ],
  declarations: [BillingComponent],
  providers: [BillingService, OpdPatientConfigService]
})
export class BillingModule {
}



// WEBPACK FOOTER //
// D:/CODE_REPOSITORIES/HIMS/HIMS_FRONTEND/src/app/billing/billing.module.ts